/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokens } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokens';
import {
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensFromJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensToJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokens';
import type { FxIdApplicationHandlersAuthAuthenticateWithExternalIdState } from './FxIdApplicationHandlersAuthAuthenticateWithExternalIdState';
import {
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSON,
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSON,
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateWithExternalIdState';
import type { FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptions } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptions';
import {
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsFromJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsToJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptions';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse
 */
export interface FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse {
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateWithExternalIdState}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse
     */
    State: FxIdApplicationHandlersAuthAuthenticateWithExternalIdState;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokens}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse
     */
    Tokens?: FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokens | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse
     */
    Hint: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse
     */
    Email?: string | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptions}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse
     */
    TransferOptions?: FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptions | null;
}



/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdResponse(value: object): value is FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse {
    if (!('State' in value) || value['State'] === undefined) return false;
    if (!('Hint' in value) || value['Hint'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'State': FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSON(json['State']),
        'Tokens': json['Tokens'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensFromJSON(json['Tokens']),
        'Hint': json['Hint'],
        'Email': json['Email'] == null ? undefined : json['Email'],
        'TransferOptions': json['TransferOptions'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsFromJSON(json['TransferOptions']),
    };
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseToJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'State': FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSON(value['State']),
        'Tokens': FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensToJSON(value['Tokens']),
        'Hint': value['Hint'],
        'Email': value['Email'],
        'TransferOptions': FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsToJSON(value['TransferOptions']),
    };
}

